import { ref, watch } from 'vue'

/**
 * Реактивное хранилище на основе localStorage
 */
export function useStorage(key, defaultValue = null) {
  // Читаем начальное значение из localStorage
  const read = () => {
    try {
      const item = localStorage.getItem(key)
      return item ? JSON.parse(item) : defaultValue
    } catch (e) {
      console.error(`Error reading localStorage key "${key}":`, e)
      return defaultValue
    }
  }

  // Создаем реактивную ссылку
  const storedValue = ref(read())

  // Записываем значение в localStorage
  const write = (value) => {
    try {
      if (value === null || value === undefined) {
        localStorage.removeItem(key)
        storedValue.value = defaultValue
      } else {
        localStorage.setItem(key, JSON.stringify(value))
        storedValue.value = value
      }
    } catch (e) {
      console.error(`Error writing localStorage key "${key}":`, e)
    }
  }

  // Слушаем изменения в других вкладках
  const handleStorageChange = (e) => {
    if (e.key === key && e.newValue !== null) {
      try {
        storedValue.value = JSON.parse(e.newValue)
      } catch (e) {
        console.error(`Error parsing storage change for key "${key}":`, e)
      }
    }
  }

  // Подписываемся на события storage
  if (typeof window !== 'undefined') {
    window.addEventListener('storage', handleStorageChange)
  }

  // Следим за изменениями и синхронизируем с localStorage
  watch(storedValue, (newValue) => {
    if (newValue !== read()) {
      write(newValue)
    }
  }, { deep: true })

  return {
    value: storedValue,
    set: write,
    remove: () => write(null)
  }
}

/**
 * Простые утилиты для работы с localStorage
 */
export const storage = {
  get(key, defaultValue = null) {
    try {
      const item = localStorage.getItem(key)
      return item ? JSON.parse(item) : defaultValue
    } catch (e) {
      return defaultValue
    }
  },
  
  set(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value))
      return true
    } catch (e) {
      console.error(`Error setting localStorage key "${key}":`, e)
      return false
    }
  },
  
  remove(key) {
    try {
      localStorage.removeItem(key)
      return true
    } catch (e) {
      return false
    }
  },
  
  clear() {
    try {
      localStorage.clear()
      return true
    } catch (e) {
      return false
    }
  }
}

